export const ADDRESS_VERIFICATION_API_RESOURCE_KEY = 'address-verification-api';